<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/patagonia/products/*', { eager: true });

useHead({});

const products = [
	{
		title: 'Better Sweater',
		src: imagesGlob['../../images/brands/patagonia/products/better-sweater.png'].default
	},
	{
		title: 'Terravia Mini Hip Pack',
		src: imagesGlob['../../images/brands/patagonia/products/terravia-mini-hip-pack.png'].default
	},
	{
		title: 'Black Hole Matte Duffel',
		src: imagesGlob['../../images/brands/patagonia/products/black-hole-matte-duffel.png'].default
	},
	{
		title: 'Brodeo Beanie',
		src: imagesGlob['../../images/brands/patagonia/products/brodeo-beanie.png'].default
	},
	{
		title: 'Nano Puff Vest',
		src: imagesGlob['../../images/brands/patagonia/products/nano-puff-vest.png'].default
	},
	{
		title: 'Atom Sling',
		src: imagesGlob['../../images/brands/patagonia/products/atom-sling.png'].default
	},
	{
		title: 'Refugio Backpack',
		src: imagesGlob['../../images/brands/patagonia/products/refugio-backpack.png'].default
	},
	{
		title: 'Torrentshell 3L Rain Jacket',
		src: imagesGlob['../../images/brands/patagonia/products/torrentshell-3l-rain-jacket.png'].default
	},
	{
		title: 'R1 Pullover',
		src: imagesGlob['../../images/brands/patagonia/products/r1-pullover.png'].default
	},
]
</script>

<template lang="pug">
.page.page--brand.patagonia
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/patagonia/logo.png')
				h1 Custom Patagonia
			.image
				img(src='@static/images/brands/patagonia/hero.jpg' alt="Woman wearing Patagonia gear stands in nature, overlooking a snowy mountain landscape.")
	section.section.section--subhero
		.section__content
			.copy
				h3 WE'RE IN BUSINESS OF THE PLANET
				p Custom Patagonia by Swagger blends performance, purpose, and elevated design to create gear that’s built for the outdoors and made to move through everyday life. Known for its long-standing commitment to environmental and social responsibility, Patagonia crafts durable, go-anywhere essentials using high-quality, low-impact materials for those who care about quality, impact, and the bigger picture. From the office to the trail, every piece is made with intention.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Patagonia ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="patagonia")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/patagonia/banner.jpg' alt="Man wearing Patagonia gear stands in a snowy landscape holding a 1% for the Planet flag.")
			.section__content
				.copy
					h2 GIFTING WITH IMPACT
					p Patagonia is a certified B Corporation and a global leader in sustainable business. Their products are made with recycled and organic materials, designed to last, and manufactured through ethical, transparent supply chains. Corporate gifting with Patagonia reflects your brand’s values, offering thoughtful, high-quality gear that supports people and the planet.
		
		section.section.section--foot
			.bg
			.section__content
		
</template>

<style></style>